// src/app/core/interceptors/header.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip interceptor for non-API requests
  if (!req.url.includes('dev.bellaspeak.com') && !req.url.includes('staging.bellaspeak.com') &&
      !req.url.includes('prod-course-lesson.bellaspeak.com') && !req.url.includes('studio.bellaspeak.net'))  {
    return next(req);
  }

  // ── Auth ──────────────────────────────────────────────────────────────────
  const accessToken = localStorage.getItem('accessToken') || environment.defaultHeaders?.accessToken;
  const garbage = localStorage.getItem('garbage') || environment.defaultHeaders?.garbage;

  // ── Language / Course ─────────────────────────────────────────────────────
  const idLL   = localStorage.getItem('idLL')    || environment.defaultHeaders?.idLL;
  const idCL   = localStorage.getItem('idCL')    || environment.defaultHeaders?.idCL;
  const courseId = localStorage.getItem('courseId') || '';
  const idC    = localStorage.getItem('courseId') || '';
  const stepId  = localStorage.getItem('currentStepId') || '';
  // ✅ idCs — comma-separated assigned course IDs from contentScope (non-admin only)
  // Stored in auth.ts saveAuthenticationData() as: localStorage.setItem('courseIds', courseIdsString)
  // For admin this is '' (empty string), for reviewer/teacher/translator it's "id1,id2,..."
  const idCs = localStorage.getItem('courseIds') || '';

  // ── Role ──────────────────────────────────────────────────────────────────
  const selectedRoleBundle = localStorage.getItem('selectedRole') || '';
  const role = selectedRoleBundle.replace('_bundle', '');
  const roleName = localStorage.getItem('roleName')
  // ── Lesson / Card ─────────────────────────────────────────────────────────
  const lessonId = localStorage.getItem('currentLessonId') || '';
  const cardId   = localStorage.getItem('currentCardId')   || '';

  // ── FormData detection ────────────────────────────────────────────────────
  const isFormData = req.body instanceof FormData;

  // ── Build headers ─────────────────────────────────────────────────────────
  const headers: { [key: string]: string } = {
    'accessToken':            accessToken,
    'garbage':                garbage,
    'idLL':                   idLL,
    'idCL':                   idCL,
    // 'stepId':                 stepId,
    'X-Internal-Service-Key': environment.internalServiceKey,
    'Cache-Control':          'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
    'Pragma':                 'no-cache',
    'Expires':                '0'
  };

  // ── Conditional headers ───────────────────────────────────────────────────

  // role
  if (role) {
    headers['role'] = role;
  }
 if (roleName) {
    headers['roleName'] = roleName;
  }

  // courseId — required for BLS-784 GET /gaL
  if (courseId) {
    headers['courseId'] = courseId;
  }

  // idC — required for lesson APIs
  if (idC) {
    headers['idC'] = idC;
  }

  // ✅ idCs — assigned course IDs (skip for admin since courseIds is '' for admin)
  if (idCs) {
    headers['idCs'] = idCs;
  }

  // lessonId — required for step/card APIs
  if (lessonId) {
    headers['lessonId'] = lessonId;
  }

  // cardId — required for single card fetch APIs
  if (cardId) {
    headers['cardId'] = cardId;
  }

  // Content-Type — JSON only, never for FormData
  if ((req.method === 'POST' || req.method === 'PUT') && req.body && !isFormData) {
    headers['Content-Type'] = 'application/json';
  } else if (isFormData) {
  }

  // ── Clone and forward ─────────────────────────────────────────────────────
  const clonedReq = req.clone({ setHeaders: headers });
  return next(clonedReq);
};
